// eslint-disable-next-line @nx/enforce-module-boundaries
import { v4 as uuidv4, v5 as uuidv5, validate as validateUUID } from 'uuid';
import isUUID from 'validator/es/lib/isUUID';

export const genUUIDV4 = uuidv4; // generate a version 4 (random) UUID
export const genUUIDV5 = (text: string, namespace = uuidv5.URL) => uuidv5(text, namespace); // generate a version 5 (deterministic) UUID from some text and a UUID namespace
export const validateUUIDV4 = validateUUID;
export const formatUUID = (id?: string) => (typeof id === 'string' ? (isUUID(id) ? id : genUUIDV5(id)) : undefined);
